import { Component, ChangeDetectionStrategy } from '@angular/core';


@Component({
	selector: 'admissions-overview-tab-1-part',
	standalone: true,
	templateUrl: './admissions-overview-tab-1.part.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrls: [`./admissions-overview-tab-1.part.scss`],
})
export class AdmissionsOverviewTab1Part {
}
